document.addEventListener('DOMContentLoaded', function () {
    const roadmapSections = document.querySelectorAll('.js-section-roadmap-block');

    roadmapSections.forEach((roadmap) => {
        const steps = roadmap.querySelectorAll('.js-section-roadmap-steps-block__step');

        steps.forEach((step) => {
            const titleContainer = step.querySelector('.js-section-roadmap-steps-block__step-title-container');
            const description = step.querySelector('.js-section-roadmap-steps-block__step-description');
            const togglePoints = step.querySelectorAll('.js-section-roadmap-steps-block-point');

            // Inicjalizacja stylów opisu
            description.style.overflow = 'hidden';
            description.style.transition = 'max-height 0.3s ease';

            if (step.classList.contains('section-roadmap-steps-block__step--active')) {
                // Jeśli krok ma klasę aktywną, rozwijamy opis
                description.style.maxHeight = description.scrollHeight + 'px';
            } else {
                // W przeciwnym razie zwijamy opis
                description.style.maxHeight = '0';
            }

            // Funkcja do przełączania stanu kroku
            const toggleStep = function () {
                // Przełączamy klasę aktywną na kroku
                const isActive = step.classList.toggle('section-roadmap-steps-block__step--active');

                // Rozwijamy lub zwijamy opis w zależności od stanu aktywności
                if (isActive) {
                    description.style.maxHeight = description.scrollHeight + 'px';
                } else {
                    description.style.maxHeight = '0';
                }
            };

            // Dodajemy nasłuchiwanie na kliknięcie w titleContainer
            titleContainer.addEventListener('click', toggleStep);

            // Dodajemy nasłuchiwanie na kliknięcie w każde togglePoint
            togglePoints.forEach(function(point) {
                point.addEventListener('click', toggleStep);
            });
        });
    });
});
